module.exports = __webpack_public_path__ + "img/support_system_v2.f90bdaf4.png";